<template>
    <ul class="container">
        <li class="header f-s-b">
            <van-image 
                class="header-iamge"
                lazy-load
                fit="contain"
                :src="imageList[0]"
            />
            <ul class="info-box">
                <li class="title">购票成功</li>
                <li class="tips">请持身份证通过验票闸机</li>
                <li class="desc">
                    用身份证购票的游客请直接刷入园；未携带证件 
                    <br>
                    的游客请凭个人中心的电子二维码过闸    前往  
                    <span class="g-yellow-color" v-touch:tap="routerPage('personalCenter')">个人中心</span>
                </li>
                <li class="btn-box f-s-b">
                    <div class="f-c back-home" v-touch:tap="routerPage('ticketing')">返回首页</div>
                    <div class="f-c look-qr" v-touch:tap="lookQr">查看入园二维码</div>
                </li>
            </ul>
        </li>
        <li class="body g-big-tree-bg">
            <ul class="body-container ">
                <li class="title">温馨提示</li>
                <van-image 
                    class="body-iamge"
                    lazy-load
                    fit="contain"
                    :src="imageList[1]"
                />
                <li class="item">
                    1.预定时间：需在游玩当天14:00前预订，预定后2小时才能入园；
                </li>
                <li class="item">
                    2.预订票中：目前平台只支持全价票购买，如需要购买优待票，请到景区相应售票窗口进行购买；
                </li>
                <li class="item">
                    3.有效期：预订游玩日期当天有效。
                </li>
                <li class="small-title g-b-500">入园须知</li>
                <li class="item">
                    入园方式：支付成功后凭订单中的二维码扫描入园；
                </li>
                <li class="item">
                    1.景区开放时间：
                </li>
                <li class="item time">
                    夏季：08:30 ~ 18:30
                </li>
                <li class="item time">
                    冬季：09:30 ~ 17:00
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
    export default {
        data() {
            return {
                imageList:[
                    require('@image/home/287634.png'),
                    require('@image/home/21321321.png'),
                ],
                id: '',
            }
        },
        created() {
            let { id } = this.$route.query;
            this.id = id;
        },
        methods: {
            routerPage(name){
                return ()=> this.$router.push({ name })
            },
            lookQr(){
                //  查看二维码
                this.$router.push({ name: "QRCode", query: { id: this.id, tyep: 'tickets' } })
            },
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        box-sizing: border-box;
        padding: 7px;
        .header{
            box-sizing: border-box;
            padding: 28px 30px;
            flex-direction: column;
            // height:424px;
            height: auto;
            background-color:rgba(255,255,255,1);
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            border-radius:5px;
            
            .header-iamge{
                width: 150px;
                margin-bottom: 16px;
            }
            .info-box{
                width: 100%;
                .title,
                .tips{
                    text-align: center;
                }
                .title{
                    font-size:18px;
                    font-weight:600;
                    color:rgba(54,92,132,1);
                }
                .tips{
                    margin: 6px 0 23px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(71,75,78,1);
                }
                .desc{
                    text-align: center;
                    font-size: 12px;
                    margin-bottom: 40px;
                    color: #626262;
                }
                .back-home{
                    color: rgba(105,170,254,1);;
                    width:135px;
                    height:37px;
                    border-radius:5px;
                    border:1px solid rgba(105,170,254,1);
                    box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                }
                .look-qr{
                    transition: all .3s ease;
                    color: #ffffff;
                    width:135px;
                    height:37px;
                    background:rgba(92,162,253,1);
                    border-radius:5px;
                    box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                }
            }
        }
        .body{
            margin-top: 7px;
            border-radius:5px;
            overflow: hidden;
            background:rgba(255,255,255,1);
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            background-size: 118px 142px;
            background-repeat: no-repeat;
            background-position: right 70%;
            background-image: url('../../lib/image/home/567.png');
            .body-container{
                box-sizing: border-box;
                width: 100%;
                padding: 14px 30px;
                font-size: 12px;
                color: #565656;
                height: auto;
                .title{
                    text-align: center;
                    color: #242424;
                    font-size: 16px;
                }
                .small-title{
                    font-size: 14px;
                    color: #565656;
                    margin: 5px 0;
                }
                .body-iamge{
                    width: 100%;
                    margin: 10px 0;
                }
                .item{
                    margin-top: 5px;
                }
                .time{
                    text-indent: 9px;
                    letter-spacing: 1px;
                }
            }
        }
    }
</style>